import styled from 'styled-components/macro';
import LoadingIndicator from '@uhg-uicl/ui-core/dist/LoadingIndicator';
import Text from '@uhg-uicl/ui-core/dist/Text';

const LoadingPage = ({ ...props }: any) => {
  const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${props?.containerHeight || '250px'};
  `;

  const StyledText = styled(Text)`
    position: absolute;
    margin-top: 100px;
  `;

  return (
    <Container>
      <LoadingIndicator length="50px" {...props} />
      {props?.message && (
        <StyledText singleLine variant="large">
          {props.message}
        </StyledText>
      )}
    </Container>
  );
};

export default LoadingPage;
